import { DateTime } from 'luxon';

import { DATE_FORMATS } from './Helpers';

let DEFAULT_TIMEZONE = localStorage.getItem('client_timezone');

export function setGlobalTimezone(tz) {
  DEFAULT_TIMEZONE = tz;
}

export function getGlobalTimezone() {
  return DEFAULT_TIMEZONE;
}

class _PFDate {
  constructor(date, zone) {
    const timezone = DEFAULT_TIMEZONE || zone;

    if (!date) {
      this.dt = DateTime.now().setZone(timezone);
    } else if (typeof date === 'string' || typeof date === 'number') {
      const parsedDate = DateTime.fromISO(date.toString(), { zone: timezone });
      this.dt = parsedDate.isValid
        ? parsedDate
        : DateTime.fromJSDate(new Date(date), { zone: timezone });
    } else {
      this.dt = DateTime.fromJSDate(date, { zone: timezone });
    }
  }

  static now() {
    return new _PFDate();
  }

  static parse(date) {
    return new _PFDate(date);
  }

  static utc() {
    return new _PFDate(undefined, 'utc');
  }

  format(fmt = DATE_FORMATS.SERVER_DATE_TIME) {
    return this.dt.toFormat(fmt);
  }

  toDate() {
    return this.dt.toJSDate();
  }

  toISOString() {
    return this.dt.toISO();
  }

  toUnix() {
    return Math.floor(this.dt.toSeconds());
  }

  valueOf() {
    return this.dt.toMillis();
  }

  startOf(unit) {
    this.dt = this.dt.startOf(unit);

    return this;
  }

  endOf(unit) {
    this.dt = this.dt.endOf(unit);

    return this;
  }

  isBefore(otherDate) {
    return this.dt < otherDate.dt;
  }

  isAfter(otherDate) {
    return this.dt > otherDate.dt;
  }

  tz(zone) {
    this.dt = this.dt.setZone(zone, { keepLocalTime: true });

    return this;
  }

  getZone() {
    return this.dt.zoneName;
  }

  isValid() {
    return this.dt.isValid;
  }

  fromNow() {
    return this.dt.toRelative();
  }

  diff(otherDate, unit = 'milliseconds', float = false) {
    const diff = this.dt.diff(otherDate.dt, unit).as(unit);

    return float ? diff : Math.trunc(diff);
  }

  isSameOrAfter(otherDate, unit = 'milliseconds') {
    if (!(otherDate instanceof _PFDate) || !otherDate.dt?.isValid) {
      return false;
    }
    return this.dt > otherDate.dt || this.dt.hasSame(otherDate.dt, unit);
  }

  startOfDay() {
    this.dt = this.dt.startOf('day');
    return this;
  }

  endOfDay() {
    this.dt = this.dt.endOf('day');
    return this;
  }
  DBFormat(fmt = 'yyyy-MM-dd') {
    return this.dt.setZone('local').toFormat(fmt);
  }

  toClientFormat(fmt = 'MM-dd-yyyy hh:mm:ss a', clientTz = DEFAULT_TIMEZONE) {
    const localDate = this.dt.setZone(clientTz);
    return localDate.toFormat(fmt);
  }
}

function PFDate(date) {
  return new _PFDate(date);
}

export default PFDate;
